/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { VFileUpload } from 'vuetify/labs/VFileUpload'
import { VDateInput } from 'vuetify/labs/VDateInput'

// Composables
import {createVuetify} from 'vuetify'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  defaults: {
    global: {
      style: {
        fontFamily: "'Atkinson Hyperlegible', Arial, sans-serif",
      },
      elevation: 0,
    },
    VDataTable: {
      itemsPerPage: 50,
      itemsPerPageOptions: [{value: 50, title: '50'}, {value: -1, title: 'Alle'}],
      itemsPerPageText: 'Items per pagina',
      pageText: '{0}-{1} van {2}',
    },
    VBtn: {
      // ripple: false,
    },
    VMenu: {
      border: 0,
    },
    VSelect: {
      hideDetails: true,
    },
    VAlert: {
      style: {
        fontSize: '1.25rem',
      }
    }
  },
  components: {
    VFileUpload, VDateInput,
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#2e3f69',
          secondary: '#4c7bf2',
          success: '#299440',
          error: '#BB4141',

          primaryLight: '#6A94FF',
          primaryDark: '#191E2D',
          zieGray: '#D2D4D6',
          zieGray2: '#E3E4E5',
          zieGray3: '#F1F2F3',
        },
        variables: {
          'light-opacity': 0.5,
        },
      },
    },
  },
})
